import {
  Button,
  Card,
  Grid,
  Typography,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import MuiMenuItem from "@material-ui/core/MenuItem";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import {
  TextValidator,
  ValidatorForm,
  SelectValidator,
} from "react-material-ui-form-validator";
import ValidatedDatePicker from "../../compartidos/ValidatedDatePicker";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import moment from "moment";
import "moment/locale/es";
import React, { useEffect, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import { startAlerta } from "../../../actions/ui/alertas";
import { conveniosPrevisualizacion } from "../../../actions/contrataciones/contratacionesConvenios";
import { CATEGORIAS_VALORIZACIONES_ARRAY } from "../../../utils/constants";
import BuscadorPractica from "./BuscadorPractica";

const MenuItem = withStyles({
  root: {
    justifyContent: "center",
  },
})(MuiMenuItem);

export const ConveniosNomencladosGalenoGastos = (props) => {
  moment.locale("es");
  const dispatch = useDispatch();
  const childRefDesde = useRef(null);
  const childRefHasta = useRef(null);

  const { dataContrato } = useSelector((state) => state.contrataciones);

  const {
    idCategoria,
    fechaInicioVigencia,
    codDesde,
    codHasta,
    galenoQuirurgico,
    gastoQuirurgico,
    galenoRadiologico,
    gastoRadiologico,
    galenoEcografico,
    gastoEcografico,
    galenoTAC,
    gastoTAC,
    galenoUTI,
    gastoUTI,
    galenoBioquimico,
    gastoBioquimico,
    galenoConsulta,
    gastoUnidadPension,
    galenoPractica,
    otrosGastos,
  } = props.formValues;

  const submitHandler = (e) => {
    e.preventDefault();

    const codPracticaHasta = codHasta ? codHasta.codNom : codDesde?.codNom;

    if (!codDesde && codHasta) {
      dispatch(startAlerta("Ingrese un Codigo Desde.", "error"));
    } else if (codPracticaHasta < codDesde?.codNom) {
      dispatch(
        startAlerta("El Codigo Hasta debe ser mayor al Codigo Desde.", "error")
      );
    } else {
      if (codDesde && codPracticaHasta) {
        const preData = {
          ...props.formValues,
        };

        const dataFormateda = {
          ...preData,
          capitulos: [],
          codigoPracticaDesde: codDesde?.codNom,
          codigoPracticaHasta: codPracticaHasta,
          galenoBioquimico: parseFloat(preData.galenoBioquimico),
          galenoConsulta: parseFloat(preData.galenoConsulta),
          galenoEcografico: parseFloat(preData.galenoEcografico),
          galenoPractica: parseFloat(preData.galenoPractica),
          galenoQuirurgico: parseFloat(preData.galenoQuirurgico),
          galenoRadiologico: parseFloat(preData.galenoRadiologico),
          galenoTAC: parseFloat(preData.galenoTAC),
          galenoUTI: parseFloat(preData.galenoUTI),
          gastoBioquimico: parseFloat(preData.gastoBioquimico),
          gastoEcografico: parseFloat(preData.gastoEcografico),
          gastoQuirurgico: parseFloat(preData.gastoQuirurgico),
          gastoRadiologico: parseFloat(preData.gastoRadiologico),
          gastoTAC: parseFloat(preData.gastoTAC),
          gastoUTI: parseFloat(preData.gastoUTI),
          gastoUnidadPension: parseFloat(preData.gastoUnidadPension),
          otrosGastos: parseFloat(preData.otrosGastos),
        };

        dispatch(
          conveniosPrevisualizacion(
            dataFormateda,
            props.setShowPrevisualizacion
          )
        );
      }

      props.openModalPracticasHandler();
    }
  };

  // VALIDATORS
  useEffect(() => {
    const fechaInicioVigenciaContrato = dataContrato?.fechaInicioVigencia;
    const fechaFinVigenciaContrato = dataContrato?.fechaFinVigencia;

    // FECHA INICIO VIGENCIA
    ValidatorForm.addValidationRule(
      "isAfterFechaInicioVigenciaContrato",
      (value) => {
        if (
          moment(value).isValid() &&
          moment(value).isBefore(moment(fechaInicioVigenciaContrato))
        ) {
          return false;
        }
        return true;
      }
    );

    // FECHA INICIO VIGENCIA
    ValidatorForm.addValidationRule(
      "isBeforeFechaFinVigenciaContrato",
      (value) => {
        if (
          moment(value).isValid() &&
          moment(value).isAfter(moment(fechaFinVigenciaContrato))
        ) {
          return false;
        }
        return true;
      }
    );
  });

  return (
    <Card style={{ padding: "1rem" }}>
      <ValidatorForm onSubmit={submitHandler}>
        <Grid container spacing={1}>
          <Grid item xs={8}>
            <MuiPickersUtilsProvider locale={esLocale} utils={DateFnsUtils}>
              <ValidatedDatePicker
                fullWidth={true}
                margin="normal"
                label="Fecha Inicio Vigencia"
                format="dd/MM/yyyy"
                maxDate={moment(new Date()).add(3, "Y")}
                okLabel="Aceptar"
                clearLabel="Limpiar"
                cancelLabel="Cancelar"
                name="fechaInicioVigencia"
                value={
                  fechaInicioVigencia !== undefined &&
                    moment(fechaInicioVigencia).isValid()
                    ? moment(fechaInicioVigencia)
                    : null
                }
                onChange={(e) => props.setearValor("fechaInicioVigencia", e)}
                disabled={props.fieldsDisabled}
                KeyboardButtonProps={{
                  "aria-label": "change date",
                }}
                validators={[
                  "required",
                  "isAfterFechaInicioVigenciaContrato",
                  "isBeforeFechaFinVigenciaContrato",
                ]}
                errorMessages={[
                  "La fecha de inicio de vigencia es requerida",
                  "La fecha de inicio de vigencia debe ser mayor a la fecha de inicio de vigencia del contrato",
                  "La fecha de inicio de vigencia debe ser menor a la fecha de fin de vigencia del contrato",
                ]}
              />
            </MuiPickersUtilsProvider>
          </Grid>
          <Grid item xs={4}>
            <SelectValidator
              fullWidth
              margin="normal"
              label="Categoria"
              name="idCategoria"
              value={idCategoria}
              onChange={props.handleInputChange}
              disabled={props.fieldsDisabled}
            >
              <MenuItem value={""}><em>Seleccione...</em></MenuItem>
              {CATEGORIAS_VALORIZACIONES_ARRAY.map(e => <MenuItem key={e.id} value={e.id}>{e.descripcion}</MenuItem>)}
            </SelectValidator>
          </Grid>
          <Grid item xs={12} style={{ marginTop: "0.5rem" }}>
            <BuscadorPractica ref={childRefDesde} cod={codDesde} label="Código Desde" fieldsDisabled={props.fieldsDisabled} setCod={(val) => props.setearValor("codDesde", val)} />
          </Grid>
          <Grid item xs={12} style={{ marginTop: "0.5rem" }}>
            <BuscadorPractica ref={childRefHasta} cod={codHasta} label="Código Hasta" fieldsDisabled={props.fieldsDisabled} setCod={(val) => props.setearValor("codHasta", val)} />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="h6" style={{ textAlign: "center", marginTop: "0.5rem" }}>
              GALENOS
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="h6" style={{ textAlign: "center", marginTop: "0.5rem" }}>
              GASTOS
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              margin="dense"
              variant="outlined"
              label="QUIRÚRGICO (QX)"
              name="galenoQuirurgico"
              value={galenoQuirurgico}
              onChange={props.handleInputChange}
              disabled={props.fieldsDisabled}
              validators={["isFloat"]}
              errorMessages={["El campo debe ser numerico"]}
            />
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              margin="dense"
              variant="outlined"
              label="QUIRÚRGICO (QX)"
              name="gastoQuirurgico"
              value={gastoQuirurgico}
              onChange={props.handleInputChange}
              disabled={props.fieldsDisabled}
              validators={["isFloat"]}
              errorMessages={["El campo debe ser numerico"]}
            />
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              margin="dense"
              variant="outlined"
              label="PRACTICA"
              name="galenoPractica"
              value={galenoPractica}
              onChange={props.handleInputChange}
              disabled={props.fieldsDisabled}
              validators={["isFloat"]}
              errorMessages={["El campo debe ser numerico"]}
            />
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              margin="dense"
              variant="outlined"
              label="OTROS GASTOS"
              name="otrosGastos"
              value={otrosGastos}
              onChange={props.handleInputChange}
              disabled={props.fieldsDisabled}
              validators={["isFloat"]}
              errorMessages={["El campo debe ser numerico"]}
            />
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              margin="dense"
              variant="outlined"
              label="RADIOLÓGICO (RX)"
              name="galenoRadiologico"
              value={galenoRadiologico}
              onChange={props.handleInputChange}
              disabled={props.fieldsDisabled}
              validators={["isFloat"]}
              errorMessages={["El campo debe ser numerico"]}
            />
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              margin="dense"
              variant="outlined"
              label="RADIOLÓGICO (RX)"
              name="gastoRadiologico"
              value={gastoRadiologico}
              onChange={props.handleInputChange}
              disabled={props.fieldsDisabled}
              validators={["isFloat"]}
              errorMessages={["El campo debe ser numerico"]}
            />
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              margin="dense"
              variant="outlined"
              label="ECOGRAFICO (ECO)"
              name="galenoEcografico"
              value={galenoEcografico}
              onChange={props.handleInputChange}
              disabled={props.fieldsDisabled}
              validators={["isFloat"]}
              errorMessages={["El campo debe ser numerico"]}
            />
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              margin="dense"
              variant="outlined"
              label="ECOGRAFICO (ECO)"
              name="gastoEcografico"
              value={gastoEcografico}
              onChange={props.handleInputChange}
              disabled={props.fieldsDisabled}
              validators={["isFloat"]}
              errorMessages={["El campo debe ser numerico"]}
            />
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              margin="dense"
              variant="outlined"
              label="TOMOGRAFÍA (TAC)"
              name="galenoTAC"
              value={galenoTAC}
              onChange={props.handleInputChange}
              disabled={props.fieldsDisabled}
              validators={["isFloat"]}
              errorMessages={["El campo debe ser numerico"]}
            />
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              margin="dense"
              variant="outlined"
              label="TOMOGRAFÍA (TAC)"
              name="gastoTAC"
              value={gastoTAC}
              onChange={props.handleInputChange}
              disabled={props.fieldsDisabled}
              validators={["isFloat"]}
              errorMessages={["El campo debe ser numerico"]}
            />
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              margin="dense"
              variant="outlined"
              label="BIOQUÍMICO (BIO)"
              name="galenoBioquimico"
              value={galenoBioquimico}
              onChange={props.handleInputChange}
              disabled={props.fieldsDisabled}
              validators={["isFloat"]}
              errorMessages={["El campo debe ser numerico"]}
            />
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              margin="dense"
              variant="outlined"
              label="BIOQUÍMICO (BIO)"
              name="gastoBioquimico"
              value={gastoBioquimico}
              onChange={props.handleInputChange}
              disabled={props.fieldsDisabled}
              validators={["isFloat"]}
              errorMessages={["El campo debe ser numerico"]}
            />
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              margin="dense"
              variant="outlined"
              label="UTI"
              name="galenoUTI"
              value={galenoUTI}
              onChange={props.handleInputChange}
              disabled={props.fieldsDisabled}
              validators={["isFloat"]}
              errorMessages={["El campo debe ser numerico"]}
            />
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              margin="dense"
              variant="outlined"
              label="UTI"
              name="gastoUTI"
              value={gastoUTI}
              onChange={props.handleInputChange}
              disabled={props.fieldsDisabled}
              validators={["isFloat"]}
              errorMessages={["El campo debe ser numerico"]}
            />
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              margin="dense"
              variant="outlined"
              label="CONSULTAS"
              name="galenoConsulta"
              value={galenoConsulta}
              onChange={props.handleInputChange}
              disabled={props.fieldsDisabled}
              validators={["isFloat"]}
              errorMessages={["El campo debe ser numerico"]}
            />
          </Grid>
          <Grid item xs={6}>
            <TextValidator
              fullWidth
              margin="dense"
              variant="outlined"
              label="UNIDAD DE PENSIÓN"
              name="gastoUnidadPension"
              value={gastoUnidadPension}
              onChange={props.handleInputChange}
              disabled={props.fieldsDisabled}
              validators={["isFloat"]}
              errorMessages={["El campo debe ser numerico"]}
            />
          </Grid>
          <Grid item xs={12}>
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{ margin: "auto", display: "block", marginTop: "2rem" }}
              disabled={props.fieldsDisabled}
            >
              Seleccionar Practicas
            </Button>
          </Grid>
        </Grid>
      </ValidatorForm>
    </Card>
  );
};
